import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Yuno payment handler.
 * Handle every non-card Yuno method (Addi BNPL, SafetyPay transfer, PagoEfectivo store) by
 * dispatching the Yuno payment action with session data from the purchase state, the same route
 * `Checkout.js` takes for any Yuno method in `handleYunoPayment`.
 */
const yunoPaymentHandler = {
  canHandle: ({ selectedPaymentMethod }) => selectedPaymentMethod?.provider === 'yuno',

  execute: async ({ purchase, onYunoPaymentAttempt }) => {
    const { selectedPaymentMethod, token: purchaseToken, yuno } = purchase;
    const { checkoutSession, merchantOrderId } = yuno || {};
    if (!checkoutSession || !merchantOrderId) {
      throw new Error(
        `Missing Yuno session data for ${selectedPaymentMethod?.type} payment attempt`,
      );
    }
    await onYunoPaymentAttempt({
      checkoutSession,
      merchantOrderId,
      selectedPaymentMethod,
      purchaseToken,
    });
  },
};

// Registered per payment type; `canHandle` wins over each type's fallback handler.
registerHandler('bnpl', yunoPaymentHandler);
registerHandler('transfer', yunoPaymentHandler);
registerHandler('store', yunoPaymentHandler);
